<template>
  <div class="settled-in-page-wrap">
    <div class="settled-in-page-inner">
      <template v-if="(pageLoaded && isCheckingSkill && pageType === 'apply') || submitSuccess">
        <div class="skill-checking">
          <img src="~@/assets/images/skill-validating.png">
          <p>
            <span>{{$t('upgrade_page_views_settled_in_before_settled_1129')}}</span>
            <span>{{$t('upgrade_page_views_settled_in_before_settled_1130')}}</span>
            <span>{{$t('upgrade_page_views_settled_in_before_settled_1131')}}</span>
            <span>{{$t('upgrade_page_views_settled_in_before_settled_1132')}}</span>
          </p>
        </div>
      </template>
      <template v-else-if="pageLoaded">
        <template v-if="pageType === 'apply'">
          <div class="welcome-text">
            <p>{{$t('upgrade_page_views_settled_in_step_2_1217')}}</p>
          </div>
          <div class="card-item profile-card">
            <div class="card-title">
              <p>{{$t('upgrade_page_views_settled_in_step_2_1218')}}</p>
            </div>
            <div class="card-body">
              <div class="avatar-box">
                <img :src="submitSkillDetail.avatarUrl || defaultAvatar" alt="">
                <button class="avatar-btn" data-key="avatarDom" data-loading="isUploadingAvatar" @click="chooseFile">
                  <i v-if="isUploadingAvatar" class="el-icon-loading" />
                  <span v-else>{{$t('upgrade_page_views_settled_in_step_2_1219')}}</span>
                </button>
                <span v-show="errors.avatarUrl" class="error-text avatar">{{$t('upgrade_page_views_settled_in_step_2_1220')}}</span>
              </div>
              <div class="simple-info">
                <div>
                  <div>{{$t('upgrade_page_views_settled_in_step_2_1221')}}</div>
                  <div>
                    <input v-model="submitSkillDetail.nickname" @input="errors.nickname = !submitSkillDetail.nickname" type="text" class="username" />
                  </div>
                  <span v-show="errors.nickname" class="error-text ml-20">{{$t('upgrade_page_views_settled_in_step_2_1222')}}</span>
                </div>
                <div>
                  <div>{{$t('upgrade_page_views_player_list_index_175')}}</div>
                  <div class="radio-group">
                    <p
                      :class="['item', submitSkillDetail.sex === 'Male' ? 'checked' : '']"
                      @click="setUserSex('Male')"
                    >
                      <i class="radio-block"></i>
                      <span>{{$t('upgrade_page_views_master_index_214')}}</span>
                      <fps-icon class="boy-icon" type="boy2" />
                    </p>
                    <p
                      :class="['item', submitSkillDetail.sex === 'Female' ? 'checked' : '']"
                      @click="setUserSex('Female')"
                    >
                      <i class="radio-block"></i>
                      <span>{{$t('upgrade_page_views_master_index_213')}}</span>
                      <fps-icon class="girl-icon" type="girl2" />
                    </p>
                  </div>
                  <span v-show="errors.sex" class="error-text ml-20">{{$t('upgrade_page_views_settled_in_step_2_1223')}}</span>
                </div>
              </div>
            </div>
            <div class="card-tip">
              <div class="card-tip-title">
                <div class="icon">Tips</div>
                <div class="text">{{$t('upgrade_page_views_settled_in_step_2_1224')}}</div>
              </div>
              <div class="templates">
                <div
                  v-for="(text, index) in templateImgs"
                  :key="'temp-img' + index"
                  class="template-item"
                >
                  <img class="item-head" :src="getTemplateImg(index)">
                  <div class="content">
                    <div v-if="text" class="err-wrap">
                      <fps-icon class="err-icon" type="close" />
                    </div>
                    <div v-else class="right-wrap">
                      <fps-icon class="right-icon" type="check" />
                    </div>
                    <span>{{ text || $t('upgrade_page_views_settled_in_step_2_1225') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-item profile-id-card">
            <div class="card-title">
              <p>{{$t('upgrade_page_views_settled_in_step_2_1226')}}</p>
              <span>{{$t('upgrade_page_views_settled_in_step_2_1227')}}</span>
            </div>
            <div class="card-body">
              <div class="text-inputs">
                <label for="input-id-card" class="content-text">{{$t('upgrade_page_views_settled_in_step_2_1228')}}</label>
                <input v-model="idCard.idNo" @input="errors.idNo = false" class="input-id-card input-id-right" id="input-id-card" type="text" :placeholder="$t('upgrade_page_views_settled_in_step_2_1229')">
                <label for="input-id-name" class="content-text">{{$t('upgrade_page_views_settled_in_step_2_1230')}}</label>
                <input v-model="idCard.realName" @input="errors.realName = false" class="input-id-card" id="input-id-name" type="text" :placeholder="$t('upgrade_page_views_settled_in_step_2_1231')">
                <span v-show="errors.idNo" class="id-no-error error-text ml-20">{{$t('upgrade_page_views_settled_in_step_2_1232')}}</span>
                <span v-show="errors.realName" class="realname-error error-text ml-20">{{$t('upgrade_page_views_settled_in_step_2_1233')}}</span>
              </div>
              <div class="image-inputs">
                <span class="content-text">{{$t('upgrade_page_views_settled_in_step_2_1234')}}</span>
                <button class="card-image-wrap" data-key="idCardDom" data-loading="isUploadingIdCard" @click="chooseFile">
                  <i v-if="isUploadingIdCard" class="el-icon-loading" />
                  <div v-else-if="idCard.idCardImage" class="id-card-bc" :style="{ backgroundImage: `url(${idCard.idCardImage})` }" />
                  <div v-else class="no-image">
                    <img src="~@/assets/image/icons/add-blue.png">
                    <span>{{$t('upgrade_page_views_settled_in_step_2_1235')}}</span>
                  </div>
                  <div class="card-tip-2">
                    <div>{{$t('upgrade_page_views_settled_in_step_2_1236')}}</div>
                    <span v-show="errors.idCardImage || errors.idCardImageBack" class="error-text ml-20">{{$t('upgrade_page_views_settled_in_step_2_1237')}}</span>
                  </div>
                </button>
                <button class="card-image-wrap card-image-wrap-back" data-key="idCardBackDom" data-loading="isUploadingIdCardBack" @click="chooseFile">
                  <i v-if="isUploadingIdCardBack" class="el-icon-loading" />
                  <div v-else-if="idCard.idCardImageBack" class="id-card-bc" :style="{ backgroundImage: `url(${idCard.idCardImageBack})` }" />
                  <div v-else class="no-image"><img src="~@/assets/image/icons/add-blue.png"><span>{{$t('upgrade_page_views_settled_in_step_2_1238')}}</span></div>
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="card-item evidence-card">
            <div class="card-title">
              <p>陪玩師經驗認證</p>
            </div>
            <div class="card-body">
              <p class="text-line">陪玩師您好，當前陪玩師入駐仍是測試階段，只接受歷史上有陪玩師經驗的陪玩師入駐哦！</p>
              <p class="text-line">请您上傳您的陪玩資質證明（例如訂單截圖or用戶資料截圖）</p>
              <p class="text-line">如果您无法提供截圖證明，請描述一下在之前平台提供的主要服務（包括您在该平台的ID和昵称）   </p>
              <div class="input-box">
                <textarea
                  v-model.trim="submitSkillDetail.playerDescription"
                  :class="{
                    'error': errors.playerDescription
                  }"
                  placeholder="點擊輸入"
                  @input="errors.playerDescription = !submitSkillDetail.playerDescription"
                ></textarea>
                <p>
                  <span :class="{
                    'error': submitSkillDetail.playerDescription.length > 100
                  }">{{ submitSkillDetail.playerDescription.length || 0 }}</span>/<span>100</span>
                </p>
              </div>
              <div class="pciture-list aptitudes-1">
                <div class="left">
                  <img v-if="!submitSkillDetail.playerOrderUrl" src="~@/assets/images/upload-aptitudes-desc.png" alt="">
                  <img v-else :src="submitSkillDetail.playerOrderUrl" alt="">
                </div>
                <div class="middle">範例：</div>
                <div class="right">
                  <img src="~@/assets/images/upload-aptitudes-desc-1.png" alt="">
                </div>
              </div>
              <div>
                <button class="normal-btn" data-key="aptitudesOrderDom" data-loading="isUploadingAptitudesOrder" @click="chooseFile">
                  <i v-if="isUploadingAptitudesOrder" class="el-icon-loading"></i>
                  <span v-else>上傳圖片</span>
                </button>
                <span v-show="errors.playerOrderUrl" class="error-text ml-20">* 圖片不能為空</span>
              </div>
              <div class="pciture-list aptitudes-2">
                <div class="left">
                  <img v-if="!submitSkillDetail.playerProfileUrl" src="~@/assets/images/upload-aptitudes-desc.png" alt="">
                  <img v-else :src="submitSkillDetail.playerProfileUrl" alt="">
                </div>
                <div class="middle">範例：</div>
                <div class="right">
                  <img src="~@/assets/images/upload-aptitudes-desc-2.png" alt="">
                </div>
              </div>
              <div>
                <button class="normal-btn" data-key="aptitudesProfileDom" data-loading="isUploadingAptitudesProfile" @click="chooseFile">
                  <i v-if="isUploadingAptitudesProfile" class="el-icon-loading"></i>
                  <span v-else>上傳圖片</span>
                </button>
                <span v-show="errors.playerProfileUrl" class="error-text ml-20">* 圖片不能為空</span>
              </div>
            </div>
          </div> -->
        </template>
        <div class="card-item skill-card">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_settled_in_step_2_1239')}}</p>
          </div>
          <div class="card-body">
            <div class="skill-select">
              <el-popover
                v-model="skillPopoverVisible"
                popper-class="popover"
                placement="bottom-start"
                :disabled="!!reapplySkillId"
              >
                <div class="popover-list-card">
                  <div
                    v-for="(skillList, cate) in skillObj"
                    :key="`category-${cate}`"
                    class="skill-popover"
                  >
                    <div class="popover-title">
                      <span>{{ cate | gameCategory }}</span>
                    </div>
                    <div class="popover-body">
                      <div
                        v-for="(skill, index) in skillList"
                        :key="index"
                        :class="{
                          'select-option': true,
                          'checked': currentSelectedSkill.gameId === skill.gameId,
                          'disabled': skill.status !== 'Uncheck' && skill.status !== 'Fail'
                        }"
                        @click="selectSkill(skill)"
                      >{{ skill.name }}</div>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="select skill">
                  <input
                    v-model="currentSelectedSkill.name"
                    type="text"
                    :placeholder="$t('upgrade_page_views_player_detail_index_1113')"
                    readonly="readonly"
                    :class="!!reapplySkillId ? 'disabled' : ''"
                  />
                </div>
              </el-popover>
              <span v-show="errors.gameId" class="error-text select-error">{{$t('upgrade_page_views_settled_in_step_2_1240')}}</span>
            </div>
            <div v-if="!currentSelectedSkill.freeMarket && currentSelectedSkill.gameId" class="level-select">
              <el-popover
                v-model="levelPopoverVisible"
                popper-class="popover"
                placement="bottom-start"
              >
                <div class="popover-list-card level">
                  <div class="skill-popover">
                    <div class="popover-body">
                      <div
                        v-for="(level, index) in currentSelectedSkill.levels"
                        :key="index"
                        :class="['select-option', currentSelectedLevel.gameLevel === level.gameLevel ? 'checked' : '']"
                        @click="selectLevel(level)"
                      >{{ level.gameLevelString }}</div>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="select skill">
                  <input v-model="currentSelectedLevel.gameLevelString" type="text" :placeholder="$t('upgrade_page_views_settled_in_step_2_1241')" readonly="readonly" />
                </div>
              </el-popover>
              <span v-show="errors.gameLevel" class="error-text select-error">{{$t('upgrade_page_views_settled_in_step_2_1242')}}</span>
            </div>
            <div v-else-if="currentSelectedSkill.gameId" class="level-select">
              <el-popover
                v-model="levelPopoverVisible"
                popper-class="popover"
                placement="bottom-start"
              >
                <div class="popover-list-card level">
                  <div class="skill-popover">
                    <div class="popover-body">
                      <div
                        v-for="(subType, index) in currentSelectedSkill.gameSubtypeList"
                        :key="index"
                        :class="['select-option', submitSkillDetail.gameSubTypeId === subType.id ? 'checked' : '']"
                        @click="selectSubType(subType)"
                      >{{ subType.name }}</div>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="select skill">
                  <input v-model="submitSkillDetail.subType" type="text" :placeholder="$t('upgrade_page_views_player_list_index_174')" readonly="readonly" />
                </div>
              </el-popover>
              <span v-show="errors.gameSubTypeId" class="error-text select-error">{{$t('upgrade_page_views_settled_in_step_2_1243')}}</span>
            </div>
          </div>
        </div>
        <div v-if="currentSelectedSkill && currentSelectedSkill.titleEditable" class="card-item skill-name-card">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_settled_in_step_2_1244')}}</p>
            <span>{{$t('upgrade_page_views_settled_in_step_2_1245')}}</span>
          </div>
          <div class="card-body">
            <input :placeholder="$t('upgrade_page_views_settled_in_step_2_1244')" maxlength="6" v-model="submitSkillDetail.skillTitle" >
            <span v-show="errors.skillTitle" class="error-text">{{$t('upgrade_page_views_settled_in_step_2_1246')}}</span>
          </div>
        </div>
        <div class="card-item picture-card">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_settled_in_step_2_1247')}}</p>
            <span>{{$t('upgrade_page_views_settled_in_step_2_1248')}}</span>
          </div>
          <div class="card-body">
            <div class="content-tip">{{$t('upgrade_page_views_settled_in_step_2_1249')}}</div>
            <div class="image-list">
              <div
                v-for="(url, i) in submitSkillDetail.screenshotImageUrlList"
                :key="'image-' + i"
                :class="i === 3 && 'last-image'"
                :style="{ backgroundImage: `url(${ url })` }"
              >
                <div class="delete-img pointer" @click="deleteImage(i)">
                  <img src="~@/assets/image/icons/close-white.png">
                </div>
              </div>
              <button v-if="!submitSkillDetail.screenshotImageUrlList || submitSkillDetail.screenshotImageUrlList.length < 4" class="upload-image" data-key="pictureDom" data-loading="isUploadingPicture" @click="chooseFile">
                <i v-if="isUploadingPicture" class="el-icon-loading"></i>
                <div v-else><img src="~@/assets/image/icons/add-blue.png"><span>{{$t('upgrade_page_views_settled_in_step_2_1290')}}{{ submitSkillDetail.screenshotImageUrlList.length ? $t('upgrade_page_views_settled_in_step_2_1291') : '' }}</span></div>
              </button>
            </div>
            <!-- <div class="image-tip">要求遊戲名稱與分數清晰。支持 jpg/jpeg/png 格式的圖片</div> -->
            <div class="example-img-title">{{$t('upgrade_page_views_settled_in_step_2_1251')}}</div>
            <div class="example-img" :style="{ backgroundImage: `url(${currentSelectedSkill.exampleUrl})` }" />
            <span v-show="errors.screenshotImageUrlList" class="error-text ml-20">{{$t('upgrade_page_views_settled_in_step_2_1252')}}</span>
            <div v-show="(submitSkillDetail.screenshotImageUrlList && submitSkillDetail.screenshotImageUrlList.length)" class="hide-id-btn">
              <div class="tips-container">Tips</div>
              <span>{{$t('upgrade_page_views_settled_in_step_2_1253')}}</span>
              <button @click="screenshotShowHide = !screenshotShowHide">{{ screenshotShowHide ? $t('upgrade_page_layout_nav_52') : $t('upgrade_page_views_settled_in_step_2_1254') }}</button>
            </div> 
            <div v-show="screenshotShowHide && submitSkillDetail.screenshotImageUrlList.length" class="game-tip2">
              <div class="example-img-title">{{$t('upgrade_page_views_settled_in_step_2_1255')}}</div>
              <div class="content-tip">{{$t('upgrade_page_views_settled_in_step_2_1256')}}</div>
            </div>
            <div v-show="screenshotShowHide && submitSkillDetail.screenshotImageUrlList.length" class="image-list">
              <div
                v-for="(url, i) in submitSkillDetail.screenshotImageUrlHideList"
                :key="'image-' + i"
                :class="i === 3 && 'last-image'"
                :style="{ backgroundImage: `url(${ url })` }"
              >
                <div class="delete-img pointer" @click="deleteImage(i, true)">
                  <img src="~@/assets/image/icons/close-white.png">
                </div>
              </div>
              <button v-if="!submitSkillDetail.screenshotImageUrlHideList || submitSkillDetail.screenshotImageUrlHideList.length < 4" class="upload-image" data-key="idPictureDom" data-loading="isUploadingIdPicture" @click="chooseFile">
                <i v-if="isUploadingIdPicture" class="el-icon-loading"></i>
                <div v-else><img src="~@/assets/image/icons/add-blue.png"><span>{{$t('upgrade_page_views_settled_in_step_2_1290')}}{{ submitSkillDetail.screenshotImageUrlHideList.length ? $t('upgrade_page_views_settled_in_step_2_1291') : '' }}</span></div>
              </button>
            </div>
          </div>
        </div>
        <div v-if="currentSelectedSkill.gameId === 3" class="card-item skill-name-card">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_settled_in_step_2_1258')}}</p>
            <span>{{$t('upgrade_page_views_settled_in_step_2_1259')}}</span>
          </div>
          <div class="card-body">
            <div class="game-input">
              <span class="input-label">{{$t('upgrade_page_views_settled_in_step_2_1260')}}</span>
              <input v-model="certificationExtraData.playerName" class="game-name-input" :placeholder="$t('upgrade_page_views_settled_in_step_2_1261')" >
              <span class="input-label">{{$t('upgrade_page_views_settled_in_step_2_1262')}}</span>
              <el-popover
                v-model="selectGameModeVisible"
                popper-class="popover"
                placement="bottom-start"
              >
                <div class="popover-list-card level">
                  <div class="skill-popover">
                    <div class="popover-body">
                      <div
                        v-for="(type, index) in $util.gameModelColumn"
                        :key="index"
                        :class="['select-option', certificationExtraData.gameMode === type.value ? 'checked' : '']"
                        @click="selectGameMode(type)"
                      >{{ type.text }}</div>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="select skill">
                  <div class="to-select-gamemode pointer" :class="certificationExtraData.gameMode && 'selected-mode'">
                    <span>{{ (certificationExtraData.gameMode || $t('upgrade_page_views_settled_in_step_2_1263')) | parseGameMode }}</span>
                    <div class="select-gamemode-right" :class="selectGameModeVisible && 'selecting'" />
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="card-item self-introduction">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_settled_in_step_2_1264')}}</p>
            <span>{{$t('upgrade_page_views_settled_in_step_2_1265')}}</span>
          </div>
          <div class="card-body">
            <div class="input-box">
              <textarea
                v-model.trim="submitSkillDetail.description"
                :class="{
                  'error': errors.description
                }"
                :placeholder="$t('upgrade_page_views_settled_in_step_2_1266')"
                @input="errors.description = !submitSkillDetail.description"
              ></textarea>
              <p>
                <span :class="{
                  'error': submitSkillDetail.description && submitSkillDetail.description.length > 250
                }">{{ submitSkillDetail.description ? submitSkillDetail.description.length : 0 }}</span>/<span>250</span>
              </p>
            </div>
            <p class="tip-line">{{ currentSelectedSkill.exampleDesc }}</p>
            <p v-show="currentSelectedLevel.gameLevelString  === $t('upgrade_page_views_settled_in_step_2_1267')" class="tip-line">{{ currentSelectedSkill.exampleText }}</p>
          </div>
        </div>
        <div class="card-item voice-introduction">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_user_info_index_723')}}</p>
          </div>
          <div class="card-body">
            <div class="voice-tool-line">
              <button class="upload-btn" data-key="voiceDom" data-loading="isUploadingVoice" @click="chooseFile">
                <i v-if="isUploadingVoice" class="el-icon-loading"></i>
                <template v-else>
                  <img src="~@/assets/images/upload-icon.png" alt="">{{$t('upgrade_page_views_settled_in_step_2_1268')}}</template>
              </button>
              <div v-if="submitSkillDetail.voiceSecond" class="voice-play">
                <!-- <VoiceTag :uuid="userInfo.uuid" :times="submitSkillDetail.voiceSecond" :voice-url="submitSkillDetail.voiceUrl" :skill="new Date().getTime()" /> -->
                <fps-voice
                  class="voice"
                  :src="submitSkillDetail.voiceUrl"
                  :init-seconds="submitSkillDetail.voiceSecond"
                  color=""
                />
              </div>
              <span v-show="errors.voiceUrl" class="error-text ml-20">{{ errors.voiceUrl === true ? $t('upgrade_page_views_user_info_index_748') : errors.voiceUrl }}</span>
            </div>
            <div class="voice-desc-line">
              <p>{{$t('upgrade_page_views_settled_in_step_2_1269')}}</p>
              <p>{{ currentSelectedSkill.exampleDesc }}</p>
            </div>
          </div>
        </div>
        <div :class="['card-item bindphone-container', userInfo.phoneNumber && 'no-bind']">
          <div class="card-title">
            <p>{{$t('upgrade_page_views_user_set_account_779')}}</p>
          </div>
          <div class="card-body">
            <div class="login-body">
              <div class="row-container">
                <label>{{$t('upgrade_page_views_settled_in_step_2_1270')}}</label>
                <div class="login-body-line input-border">
                  <div class="phone-container">
                    <div class="mobile-prefix">
                      <el-popover
                        v-model="isShowMobileAreaSelectList"
                        :visible-arrow="false"
                        popper-class="popper-clear-style"
                        placement="bottom-start"
                      >
                        <div slot="reference" class="mobile-prefix-inner">
                          <span>{{ currentSelectPrefix.code }}</span>
                          <img src="~@/assets/images/select-icon.png" alt="" />
                        </div>
                        <div
                          class="login-body-mobile-area"
                          v-clickoutside="closeMobileAreaSelectList"
                        >
                          <p
                            v-for="(item, index) in mobileAreaList"
                            :key="index"
                            @click="selectMobileArea(item.code)"
                          >
                            <span>{{ item.text }}</span>
                            <span>{{ item.code }}</span>
                          </p>
                        </div>
                      </el-popover>
                    </div>
                    <div class="mobile-input">
                      <input
                        v-model="loginObj.phoneNumber"
                        id="mobile-input"
                        type="text"
                        :placeholder="$t('upgrade_page_views_user_set_account_783')"
                      />
                    </div>
                    <div
                      v-show="showErrorMessage"
                      class="error-message"
                    >{{$t('upgrade_page_views_user_set_account_784')}}</div>
                  </div>
                </div>
              </div>
              <div class="row-container code">
                <label for="verifica-code">{{$t('upgrade_page_views_settled_in_step_2_1271')}}</label>
                <div class="login-body-line">
                  <div class="valid-code input-border">
                    <input
                      v-model="loginObj.verifyCode"
                      id="verifica-code"
                      type="text"
                      :placeholder="$t('upgrade_page_views_user_set_account_785')"
                    />
                  </div>
                  <div class="btn">
                    <button @click="getValidateCode">
                      <span v-if="isSendingSmsCode">
                        <i class="el-icon-loading"></i>{{$t('upgrade_page_views_user_set_account_786')}}</span>
                      <span v-else>{{
                        sendCodeTimer > 0
                          ? sendCodeTimer + "s"
                          : $t("upgrade_page_views_user_set_account_787")
                      }}</span>
                    </button>
                  </div>
                  </div>
                </div>
              <div id="verification-code"></div>
              <div class="bindphone-footer">
                <div
                  class="affirm-btn"
                  @click="verifyCode"
                >
                  <button>{{$t('components_bindphone_index_1100')}}</button>
                </div>
                <div v-show="needBindPhone" class="need-bind-phone">{{$t('upgrade_page_views_settled_in_step_2_1272')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-card">
          <div class="profit-line">
            <div class="title-line">
              <span @click="toggleIncomeCalDescDialog">{{$t('upgrade_page_views_settled_in_step_2_1273')}}</span>
              <img src="~@/assets/image/fps-icon/arrow-icon.png" :class="incomeCalMethodDesc ? 'show' : ''">
            </div>
            <div v-show="incomeCalMethodDesc" class="body-line">
              <p
               v-for="(d,i) in deductList"
               :key="'deduct-' + i"
              >{{ d }}</p>
            </div>
          </div>
          <div class="agreement-line">
            <p @click="toggleAgreeProtocol">
              <span class="check-box">
                <span v-if="isAgreeProtocol" class="checked-circle" />
              </span>
              <span>{{$t('upgrade_page_views_settled_in_before_settled_1136')}}</span>
            </p>
            <p>
              <span @click="jumpPage('/rules')">{{$t('upgrade_page_views_settled_in_step_2_1274')}}</span>、<span @click="jumpPage('/privacy')">{{$t('upgrade_page_views_settled_in_step_2_1275')}}</span>
            </p>
            <span v-show="!isAgreeProtocol" class="error-text protocol">{{$t('upgrade_page_views_settled_in_step_2_1276')}}</span>
          </div>
          <div>
            <button @click="validateSubmitInfo" class="submit-btn">
              <i v-if="isSubmiting" class="el-icon-loading" />
              <span v-else>{{ reapplySkillId ? $t('components_order_order_card_525') : $t('upgrade_page_views_settled_in_step_2_1277') }}</span>
            </button>
          </div>
        </div>
      </template>
    </div>
    <div v-show="false">
      <input
        type="file"
        id="id-card-back-input"
        accept="image/jpg,image/jpeg,image/png,,image/webp,image/gif"
        data-loading="isUploadingIdCardBack"
        data-key="idCardImageBack"
        @change="uploadFile"
      />
      <input
        type="file"
        id="id-card-input"
        accept="image/jpg,image/jpeg,image/png,,image/webp,image/gif"
        data-loading="isUploadingIdCard"
        data-key="idCardImage"
        @change="uploadFile"
      />
      <input
        type="file"
        id="avatar-input"
        accept="image/jpg,image/jpeg,image/png,,image/webp,image/gif"
        data-loading="isUploadingAvatar"
        data-key="avatarUrl"
        @change="uploadFile"
      />
      <input
        type="file"
        id="aptitudes-profile-input"
        accept="image/jpg,image/jpeg,image/png,image/webp"
        data-loading="isUploadingAptitudesProfile"
        data-key="playerProfileUrl"
        @change="uploadFile"
      />
      <input
        type="file"
        id="aptitudes-order-input"
        accept="image/jpg,image/jpeg,image/png,image/webp"
        data-loading="isUploadingAptitudesOrder"
        data-key="playerOrderUrl"
        @change="uploadFile"
      />
      <input
        type="file"
        id="picture-input"
        accept="image/jpg,image/jpeg,image/png,image/webp"
        data-loading="isUploadingPicture"
        data-key="screenshotImageUrlList"
        @change="uploadFile"
      />
      <input
        type="file"
        id="picture-input-id"
        accept="image/jpg,image/jpeg,image/png,image/webp"
        data-loading="isUploadingIdPicture"
        data-key="screenshotImageUrlHideList"
        @change="uploadFile"
      />
      <input
        type="file"
        id="voice-input"
        accept=".mp3,.wma,.m4a,.wav,.ape,.flac,.aac"
        data-loading="isUploadingVoice"
        data-key="voiceUrl"
        data-validate="validateVoiceInfo"
        @change="uploadFile"
      />
      <audio muted="muted" id="audio"></audio>
    </div>
    <Cropper
      v-if="cutDialogVisiable"
      :cutDialogVisiable="cutDialogVisiable"
      :originData="originData"
      @closeCut="closeCut"
      @handleAvatarSuccessP="handleAvatarSuccessP"
    />
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
import { uploadFileToS3, uploadImageToS3 } from '@/api'
import { saveUserInfo, getSmsCode } from '@/api'
import mobileAreaList from '@/utils/areas-code'
import Clickoutside from "@/utils/clickoutside"
import Cropper from '@/components/ImgCropper/index'

export default {
  directives: {
    clickoutside: Clickoutside
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: {
    Cropper
  },
  data() {
    const { fullPath, query } = this.$route
    const type = fullPath === '/first-settle' ? 'apply' : query.type === 'add' ? 'add' : 'reapply'

    const submitData = Object.assign({
      voiceUrl: '',
      screenshotImageUrlList: [],
      screenshotImageUrlHideList: [],
      description: '',
      voiceSecond: 0,
      gameId: '',
      skillId: '',
      gameLevel: '',
      skillTitle: '',
      subType: '',
      gameSubTypeId: '',
    }, type === 'apply' ? {
      avatarUrl: '',
      sex: '',
      nickname: '',
      // playerOrderUrl: '',
      // playerProfileUrl: '',
      // playerDescription: '',
    } : {})

    return {
      cutDialogVisiable: false,
      certificationExtraData: {
        gameMode: '',
        playerName: '',
      },
      selectGameModeVisible: false,
      pageLoaded: false,
      pageType: type,
      reapplySkillId: '',
      isCheckingSkill: false,
      defaultAvatar: require('@/assets/images/default-avatar.png'),
      defaultAvatarUrl: 'https://resource.3uplay.com/3uplay/avatar/img-defaultUser-min.png',
      defaultSkillImage: require('@/assets/images/upload-skill-example.png'),
      defaultSkillDesc: i18n.t('upgrade_page_views_settled_in_step_2_1278'),
      defaultSKillText: i18n.t('upgrade_page_views_settled_in_step_2_1279'),
      isAgreeProtocol: false,
      incomeCalMethodDesc: false,
      isUploadingAvatar: false,
      isUploadingAptitudesProfile: false,
      isUploadingAptitudesOrder: false,
      isUploadingPicture: false,
      isUploadingIdPicture: false,
      isUploadingVoice: false,
      isUploadingIdCard: false,
      isUploadingIdCardBack: false,
      isSubmiting: false,
      screenshotShowHide: false,
      submitSuccess: this.$route.query.type === 'checking',
      skillObj: {},
      currentSelectedSkill: {
        exampleUrl: require('@/assets/images/upload-skill-example.png'),
        exampleDesc: i18n.t('upgrade_page_views_settled_in_step_2_1280'),
        // 實況主需要添加鏈接
        exampleText: i18n.t('upgrade_page_views_settled_in_step_2_1279')
      },
      templateImgs: ['', i18n.t('upgrade_page_views_settled_in_step_2_1281'), i18n.t('upgrade_page_views_settled_in_step_2_1282'), i18n.t('upgrade_page_views_settled_in_step_2_1283'), i18n.t('upgrade_page_views_settled_in_step_2_1284'), i18n.t('upgrade_page_views_settled_in_step_2_1285')],
      currentSelectedLevel: {},
      skillPopoverVisible: false,
      levelPopoverVisible: false,
      avatarDom: null,
      pictureDom: null,
      idPictureDom: null,
      voiceDom: null,
      submitSkillDetail: submitData,
      errors: {
        avatarUrl: false,
        nickname: false,
        sex: false,
        voiceUrl: false,
        screenshotImageUrlList: false,
        gameLevel: false,
        gameId: false,
        description: false,
        playerDescription: false,
        playerProfileUrl: false,
        playerOrderUrl: false,
        skillTitle: false,
        gameSubTypeId: false,
        idCardImage: false,
        idCardImageBack: false,
      },
      mobileAreaList: mobileAreaList,
      loginObj: {
        phoneNumber: "",
        verifyCode: "",
        keyUuid: null
      },
      isSendingSmsCode: false,
      sendCodeTimer: 0,
      currentSelectPrefix: {
        code: 1
      },
      isShowMobileAreaSelectList: false,
      tencentCaptchaInstance: null,
      showErrorMessage: false,
      needBindPhone: false,
      deductList: [],
      idCard: {
        idCardImage: '',
        idCardImageBack: '',
        realName: '',
        idNo: '',
      },
    }
  },
  watch: {
    currentSelectedSkill({ freeMarket }) {
      if (freeMarket) {
        this.$set(this.submitSkillDetail, '')
      }
    }
  },
  created() {
    if (this.submitSuccess) return
    const route = this.$route
    if (this.pageType === 'apply') {
      if (this.userInfo.userKind === 'Player' && !route.query.id) {
        this.$router.replace({
          name: 'homepage'
        })

        return
      }

      this.getIdCardInfo()
      this.submitSkillDetail.avatarUrl = this.userInfo.avatarUrl
      this.submitSkillDetail.nickname = this.userInfo.nickname
      this.submitSkillDetail.sex = this.userInfo.sex
    } else {
      if (this.userInfo.userKind === 'Normal' && route.path !== '/first-settle') {
        this.$router.replace({
          name: 'homepage'
        })

        return
      }

      if (route.query.id) {
        this.reapplySkillId = route.query.id
        this.getSkillDetailInfo()
      }
    }
    this.getDeduct()
    this.$http.get('/player/skill/certification/gamelist', { gameGroupKind: 'CATEGORY' }).then(({ data }) => {
      if (data) {
        this.skillObj = data
        this.pageLoaded = true
        if (this.userInfo.userKind !== 'Player') {
          for (var attr in data) {
            for (var i in data[attr]) {
              if (data[attr][i].status === 'Checking') {
                this.isCheckingSkill = true
                return
              }
            }
          }
        }
      }
    })
  },
  mounted() {
    this.idCardDom = document.querySelector('#id-card-input')
    this.idCardBackDom = document.querySelector('#id-card-back-input')
    this.avatarDom = document.querySelector('#avatar-input')
    this.aptitudesProfileDom = document.querySelector('#aptitudes-profile-input')
    this.aptitudesOrderDom = document.querySelector('#aptitudes-order-input')
    this.pictureDom = document.querySelector('#picture-input')
    this.idPictureDom = document.querySelector('#picture-input-id')
    this.voiceDom = document.querySelector('#voice-input')
  },
  methods: {
    handleDeleteVoice() {
      this.submitSkillDetail.voiceUrl = ""
      this.submitSkillDetail.voiceSecond = 0
    },
    getTemplateImg(index) {
      return require(`@/assets/images/template-img${index+1}.png`)
    },
    closeCut() {
      this.isUploadingAvatar = false
      this.cutDialogVisiable = false
    },
    handleAvatarSuccessP(url) {
      this.submitSkillDetail.avatarUrl = url
      this.isUploadingAvatar = false
      this.cutDialogVisiable = false
    },
    selectGameMode({ value }) {
      this.$set(this.certificationExtraData, 'gameMode', value)
      this.selectGameModeVisible = false
    },
    deleteImage(i, flag) {
      if (flag) {
        this.submitSkillDetail.screenshotImageUrlHideList.splice(i, 1)
      } else {
        this.submitSkillDetail.screenshotImageUrlList.splice(i, 1)
      }
    },
    getIdCardInfo() {
      this.$http.get('/user/idcard/get')
        .then(({ data }) => {
          if (data) {
            this.idCard = data
          }
        }).catch((e) => {
          console.log(e)
        })
    },
    getDeduct() {
      new Promise((resolve) => {
        // 登录情况下获取抽成信息
        this.$http.get('/account/stolen/content').then(({ data }) => {
          resolve(data)
        })
      }).then((data) => {
        this.deductList = data.split(/\n/).filter(item => item.trim() !== '')
      })
    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      let { verifyCode, keyUuid, phoneNumber } = this.loginObj
      if (!phoneNumber) {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_801'))
        return false;
      }
      if (verifyCode.length !== 4) {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_785'))
        return false;
      }
      const { code } = this.currentSelectPrefix
      phoneNumber = code + phoneNumber
      return {
        phoneNumber,
        verifyCode,
        keyUuid,
        isSaveToken: true
      }
    },
    async verifyCode() {
      this.showErrorMessage = false
      const params = this.validateInputMsg()
      if (params && !this.isVerifying) {
        this.isVerifying = true
        let url = '/user/telephone/bind'
        this.$http.post(url, params).then(rs => {
          this.isVerifying = false
          this.$message({
            type: 'success',
            message: i18n.t('upgrade_page_views_user_set_account_790')
          })
          this.$store.dispatch('app/setUserInfo', { userInfo: rs.data })
        }).catch(rs => {
          this.isVerifying = false
          if (rs.code === 434) {
            this.showErrorMessage = true
            return
          }
          if (rs.code === 618) {
            this.$message.error(i18n.t('upgrade_page_views_user_set_account_800'))
          } else {
            this.$message.error(i18n.t('upgrade_page_views_user_set_account_789'))
          }
        })
      }
    },
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count

      if (count > 0) {
        this.codeTimerHandler = setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      } else {
        this.codeTimerHandler = null
      }
    },
    getValidateCode() {
      if (this.sendCodeTimer > 0) return
      let phoneNumber = this.loginObj.phoneNumber
      if (!phoneNumber) return this.$message.error(i18n.t('upgrade_page_views_user_set_account_783'))
      if (!this.tencentCaptchaInstance) {
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            let phoneNumber = this.currentSelectPrefix.code + this.loginObj.phoneNumber
            getSmsCode({
              phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }
              this.isSendingSmsCode = false
            }).catch(err => {
              this.isSendingSmsCode = false
              if (err.msg) {
                if (err.msg === 'InvalidParameterValue.IncorrectPhoneNumber') {
                  this.$message.error(i18n.t('upgrade_page_views_user_set_account_802'))
                  return
                }
                this.$message.error(err.msg)
              }
            })
          }
        })
      }
      this.tencentCaptchaInstance.show()
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
    jumpPage(page) {
      this.$util.openWindow(page)
    },
    /**
     * @description 查詢技能詳情
     */
    getSkillDetailInfo() {
      if (!this.reapplySkillId) return
      this.$http.get('/player/skill/detail/info', {
        id: this.reapplySkillId,
        showHide: true,
      }).then(({ data }) => {
        if (data) {
          data.certificationExtraData && (this.certificationExtraData = data.certificationExtraData)
          this.submitSkillDetail.voiceUrl = data.voiceUrl
          this.submitSkillDetail.voiceSecond = data.voiceSecond
          this.submitSkillDetail.screenshotImageUrlList = data.screenshotImageUrlList ? JSON.parse(data.screenshotImageUrlList) : []
          this.submitSkillDetail.screenshotImageUrlHideList = data.screenshotImageUrlHideList ? JSON.parse(data.screenshotImageUrlHideList) : []
          this.screenshotShowHide = data.screenshotShowHide
          this.submitSkillDetail.description = data.description
          this.submitSkillDetail.gameId = data.gameId
          if (data.titleEditable) {
            this.submitSkillDetail.skillTitle = data.gameName
          }
          if (data.freeMarket) {
            this.submitSkillDetail.subType = data.subType
            this.submitSkillDetail.gameSubTypeId = data.gameSubTypeId
          } else {
            this.submitSkillDetail.gameLevel = data.gameLevel
          }
          this.selectSkill({
            id: data.gameId,
            name: data.gameName,
            status: 'Uncheck'
          }).then(() => {
            this.currentSelectedLevel = {
              gameLevelString: data.gameLevelString,
              gameLevel: data.gameLevel
            }
          })
        }
      })
    },
    /**
     * @description 選擇文件
     */
    chooseFile({ currentTarget }) {
      const { key, loading } = currentTarget.dataset
      if (this[loading]) return
      this[key].click()
    },
    /**
     * @description 上傳文件
     */
    async uploadFile({ target }) {
      const { files, dataset: { loading, key, validate } } = target
      if (!files.length) return
      this[loading] = true
      let voiceSecond

      if (validate && this[validate]) {
        try {
          voiceSecond = await this[validate](key, files[0])
        } catch(e) {
          // TODO 錯誤提示
          this[loading] = false
          this.errors.voiceUrl = e
          this.submitSkillDetail.voiceSecond = 0
          this.submitSkillDetail.voiceUrl = ''
          console.log(e)
          return
        }
      }
      if (key !== 'avatarUrl' || files[0].type === 'image/gif') {
        const fd = new FormData()
        const handler = key === 'voiceUrl' ? uploadFileToS3 : uploadImageToS3

        fd.append('file', files[0])

        handler(fd).then(({ data }) => {
          if (data) {
            if (key === 'idCardImage' || key === 'idCardImageBack') {
              this.idCard[key] = data
            } else if (key === 'screenshotImageUrlList') {
              this.submitSkillDetail.screenshotImageUrlList = this.submitSkillDetail.screenshotImageUrlList.concat(data)
              // 清空input內的值
              this.pictureDom.value = ''
            } else if (key === 'screenshotImageUrlHideList') {
              this.submitSkillDetail.screenshotImageUrlHideList = this.submitSkillDetail.screenshotImageUrlHideList.concat(data)
              // 清空input內的值
              this.idPictureDom.value = ''
            } else {
              this.submitSkillDetail[key] = data
            }
            this.errors[key] = false

            if (voiceSecond && key === 'voiceUrl') {
              this.submitSkillDetail.voiceSecond = voiceSecond
              this.submitSkillDetail.voiceUrl = data
            }
          }

          this[loading] = false
        }).catch(() => {
          this[loading] = false
        })
      }else {
        this.originData = files[0]
        this.cutDialogVisiable = true
      }
    },
    /**
     * @description 音頻校驗
     */
    validateVoiceInfo(key, file) {
      return new Promise((resolve, reject) => {
        if (file) {
          if (file.size > 1024 * 1024 * 3) return reject(i18n.t('upgrade_page_views_user_info_index_745'))

          const url = window.URL.createObjectURL(file)
          const audio = document.querySelector('#audio')

          audio.onloadedmetadata = () => {
            const duration = audio.duration
            window.URL.revokeObjectURL(url)

            if (duration > 60 || duration < 3) {
              return reject(i18n.t('upgrade_page_views_user_info_index_746'))
            } else {
              resolve(Math.ceil(duration))
            }
          }

          audio.onerror = () => {
            reject(i18n.t('upgrade_page_views_user_info_index_747'))
          }
          audio.src = url
        } else {
          reject(i18n.t('upgrade_page_views_user_info_index_748'))
        }
      })
    },
    /**
     * @description 選擇技能
     */
    selectSkill(skill) {
      if (skill.status !== 'Uncheck' && skill.status !== 'Fail') return
      this.currentSelectedSkill = skill
      this.currentSelectedLevel = {}
      this.skillPopoverVisible = false
      this.errors.gameId = false
      this.submitSkillDetail.gameId = skill.id
      return new Promise(resolve => {
        // 獲取技能基礎信息
        this.$http.get('/player/skill/certification/gameinfo', {
          gameId: skill.id
        }).then(({ data }) => {
          const currentSelectedSkill = data
          currentSelectedSkill.gameId = data.id
          currentSelectedSkill.levels = data.gameLevelList
          currentSelectedSkill.exampleUrl = data.exampleUrl || this.defaultSkillImage
          currentSelectedSkill.exampleDesc = data.exampleDesc || this.defaultSkillDesc
          currentSelectedSkill.exampleText = data.exampleText || this.defaultSKillText
          this.currentSelectedSkill = currentSelectedSkill
          resolve()
        })
      })
    },
    /**
     * @description 選擇等級
     */
    selectLevel(level) {
      this.currentSelectedLevel = level
      this.levelPopoverVisible = false
      this.errors.gameLevel = false
      this.submitSkillDetail.gameLevel = level.gameLevel
    },
    /**
     * @description 選擇分類
     */
    selectSubType({ id, name }) {
      // this.currentSelectedLevel = id
      this.levelPopoverVisible = false
      this.errors.subType = false
      this.submitSkillDetail.subType = name
      this.submitSkillDetail.gameSubTypeId = id
    },
    /**
     * @description 選擇技能
     */
    setUserSex(sex) {
      this.submitSkillDetail.sex = sex
      this.errors.sex = false
    },
    toggleIncomeCalDescDialog() {
      this.incomeCalMethodDesc = !this.incomeCalMethodDesc
    },
    toggleAgreeProtocol() {
      this.isAgreeProtocol = !this.isAgreeProtocol
    },
    /**
     * @description 校驗提交信息
     */
    validateSubmitInfo() {
      const {
        submitSkillDetail,
        errors,
        isAgreeProtocol,
        isUploadingAvatar,
        isUploadingAptitudesProfile,
        isUploadingAptitudesOrder,
        isUploadingPicture,
        isUploadingIdPicture,
        isUploadingVoice,
        userInfo,
        idCard,
      } = this
      if (!userInfo.phoneNumber) {
        this.needBindPhone = true
        return
      }
      // 有上傳任務進行時，停止操作
      if (isUploadingAvatar || isUploadingAptitudesProfile || isUploadingAptitudesOrder || isUploadingPicture || isUploadingVoice || isUploadingIdPicture) return
      const validateObj = { ...submitSkillDetail }
      if (this.currentSelectedSkill.freeMarket) {
        delete validateObj.gameLevel
      } else {
        delete validateObj.subType
        delete validateObj.gameSubTypeId
      }
      if (!this.currentSelectedSkill.titleEditable) {
        delete validateObj.skillTitle
      }
      for(let key in validateObj) {
        if (errors.hasOwnProperty(key)) {
          errors[key] = !submitSkillDetail[key]
        }
      }
      if (!submitSkillDetail.screenshotImageUrlList.length) {
        errors.screenshotImageUrlList = true
      }

      if (submitSkillDetail.description.length > 250) {
        errors.description = true
      }

      if (this.pageType === 'apply') {
        // if (submitSkillDetail.playerDescription.length > 100) {
        //   errors.playerDescription = true
        // }

        // 校验默认头像
        if (submitSkillDetail.avatarUrl === this.defaultAvatarUrl) {
          errors.avatarUrl = true
        }
        // 校验身份证信息
        if (!idCard.idNo) {
          errors.idNo = true
        }
        if (!idCard.realName) {
          errors.realName = true
        }
        if (!idCard.idCardImage) {
          errors.idCardImage = true
        }
        if (!idCard.idCardImageBack) {
          errors.idCardImageBack = true
        }
      }

      // 必填信息校驗通過
      if (Object.keys(submitSkillDetail).concat(Object.keys(idCard)).every(i => !errors[i])) {
        if (isAgreeProtocol) {
          this.submitSkillValidate()
        }
      }
    },
    /**
     * @description 提交技能審核
     */
    async submitSkillValidate() {
      const { isSubmiting, submitSkillDetail, currentSelectedSkill, currentSelectedLevel, pageType, certificationExtraData } = this

      if (isSubmiting) return
      this.isSubmiting = true

      const skillParams = {
        gameId: currentSelectedSkill.gameId,
        screenshotImageUrlList: submitSkillDetail.screenshotImageUrlList,
        screenshotImageUrlHideList: submitSkillDetail.screenshotImageUrlHideList,
        screenshotShowHide: !!(this.screenshotShowHide && this.submitSkillDetail.screenshotImageUrlHideList.length),
        description: submitSkillDetail.description,
        voiceSecond: submitSkillDetail.voiceSecond,
        voiceUrl: submitSkillDetail.voiceUrl,
        certificationExtraData,
      }
      if (currentSelectedSkill.freeMarket) {
        skillParams.subType = submitSkillDetail.subType
        skillParams.gameSubTypeId = submitSkillDetail.gameSubTypeId
      } else {
        skillParams.gameLevel = currentSelectedLevel.gameLevel
      }
      
      if (currentSelectedSkill.titleEditable) {
        skillParams.skillTitle = submitSkillDetail.skillTitle
      }

      const userParams = {
        avatarUrl: submitSkillDetail.avatarUrl,
        sex: submitSkillDetail.sex,
        nickname: submitSkillDetail.nickname
      }
      if (skillParams.id) {
        skillParams.skillId = skillParams.id
        delete skillParams.id
      }
      if (pageType === 'apply') {
        // Object.assign(skillParams, {
        //   playerDescription: submitSkillDetail.playerDescription,
        //   playerOrderUrl: submitSkillDetail.playerOrderUrl,
        //   playerProfileUrl: submitSkillDetail.playerProfileUrl
        // })
        try {
          // 保存身分信息
          await Promise.all([saveUserInfo(userParams), this.$http.post('/user/idcard/save', this.idCard)]) 
        } catch (err) {
          console.log(err)
          switch (err.code) {
            case 614: {
              this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1286'))
              break
            }
            case 620: {
              this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1287'))
              break
            }
            default: {
              this.$message.error(i18n.t('upgrade_page_views_user_set_account_789'))
            }
          }
          this.isSubmiting = false
          return
        }
      } else if (pageType === 'reapply') {
        skillParams.skillId = this.reapplySkillId
      }

      this.$http.post('/player/skill/certification/submit', skillParams).then(() => {
        this.$message.success(i18n.t('components_order_order_card_564'))
        this.submitSuccess = true
        this.isSubmiting = false
        if(this.$route.path === '/first-settle') {
          this.$emit('toStep', 3)
        }

        this.$nextTick(() => {
          let body = document.documentElement || document.body

          body.scrollTo({
            top: 0
          })
        })
      }).catch((err) => {
        this.isSubmiting = false
        if (err.code === 623) {
          this.$message.error(i18n.t('components_order_order_card_565'))
          return
        } else if (err.code === 441) {
          this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1288'))
          return
        }
        this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1289'))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .voice-play{
    width: 94px;
    height: 36px;
    border-radius: 40px;
    background: #222C43;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
    position: relative;
    >img{
      position: absolute;
      width: 24px;
      height: 24px;
      right: -40px;
      top: 7px;
      cursor: pointer;
    }
  }
  .avatar-btn {
    background: #FFFFFF;
    border: 1px solid #222C43;
    box-sizing: border-box;
    border-radius: 4px;
    color: #222C43;
    font-size: 16px;
    line-height: 22px;
    &:hover {
      background: #222C43;
      color: #FFFFFF;
    }
    &:focus {
      background: #636D86;
      color: #FFFFFF;
      border: 1px solid #636D86;
    }
  }
  .skill-name-card {
    .card-body {
      padding: 30px 40px 40px;
    }
    input {
      width: 290px;
      height: 46px;
      border: 1px solid #999999;
      border-radius: 4px;
      padding: 12px 0 12px 20px;
      font-size: 16px;
      line-height: 22px;
      margin-right: 20px;
    }
    .game-input {
      @include flex(flex-start);
      .input-label {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        margin-right: 32px;
      }
      .game-name-input {
        width: 336px;
        height: 46px;
        border: 1px solid rgba(153, 153, 153, .5);
        border-radius: 4px;
        padding: 12px 20px;
        font-size: 16px;
        line-height: 22px;
        color: #333;
        margin-right: 40px;
        &::placeholder {
          color: #999999;
        }
      }
      .to-select-gamemode {
        width: 336px;
        height: 46px;
        border: 1px solid rgba(153, 153, 153, .5);
        border-radius: 4px;
        padding: 12px 20px;
        font-size: 16px;
        line-height: 22px;
        color: #999;
        @include flex(space-between, center);
        &.selected-mode {
          color: #333;
        }
        .select-gamemode-right {
          width: 0;
          height: 0;
          border-top: 6px solid #999;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          transition: all .3s;
          &.selecting {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .skill-popover:not(:first-child) {
    margin-top: 40px;
  }
  .card-tip {
    width: 694px;
    box-sizing: border-box;
    padding: 20px 20px 0;
    background: #F8F8F8;
    border-radius: 8px;
    margin: 0 0 50px 65px;
    .card-tip-title {
      display: flex;
      align-items: center;
      .icon {
        width: 32px;
        height: 16px;
        line-height: 16px;
        border-radius: 4px;
        background: #FF891E;
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        margin-right: 6px;
        font-style: italic;
      }
      .text {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
    }
  }
  .templates {
    padding: 30px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .template-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .item-head {
        height: 80px;
        border-radius: 50%;
        margin-bottom: 10px;
      }
      .content {
        display: flex;
        justify-content: center;
        align-items: center;
        .err-wrap {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: $color-red;
          @include flex;
          margin-right: 2px;
          .err-icon {
            font-size: 12px;
            transform: scale(.8);
            color: #fff;
          }
        }
        .right-wrap {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: $color-green;
          @include flex;
          margin-right: 2px;
          .right-icon {
            font-size: 12px;
            transform: scale(.8);
            color: #fff;
          }
        }
        span {
          font-size: 12px;
          line-height: 14px;
          color: #333333;
        }
      }
    }
  }
  .card-item {
    border: 1px solid #ececec;
    border-radius: 8px;
  }
  .row-container {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    &.code {
      margin-top: 30px;
      .login-body-line {
        justify-content: flex-start;
        align-items: center;
      }
    }
    label {
      width: 78px;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;

      color: #666666;
    }
    .login-body-line {
      flex: 1;
    }
  }
  .bindphone-container {
    transition: all .5s 4s;
    overflow: hidden;
    height: 318px;
    margin: 20px 0;
    &.no-bind {
      height: 0px;
      margin: 0px;
      border-width: 0px;
    }
    .phone-container {
      width: 280px;
      background: #FBFBFB;
      border: 1px solid #999999;
      box-sizing: border-box;
      border-radius: 4px;
    }
  }
  .popover {
    .popover-list-card {
      width: 1113px;
      padding: 5px;

      &.level {
        width: 770px;
        padding: 0;

        .popover-body {
          margin: 0;

          .select-option {
            margin-top: 0;
          }
        }
      }

      .popover-title {
        @include flex(flex-start);

        img {
          width: 22px;
          height: 22px;
          margin-right: 5px;
        }

        span {
          color: #333;
          font-size: 16px;
          font-weight: 500;
        }
      }

      .popover-body {
        @include flex(flex-start);
        flex-wrap: wrap;
        margin-top: 10px;

        .select-option {
          @include flex();
          min-width: 86px;
          height: 30px;
          font-size: 14px;
          line-height: 14px;
          margin-top: 10px;
          margin-right: 20px;
          border-radius: 4px;
          padding: 0 8px;
          cursor: pointer;
          border: 1px solid transparent;

          &:hover {
            color: white;
            background: #222C43;
          }

          &.checked {
            background: #222C43;
            color: white;
          }

          &.disabled {
            opacity: 0.3;
            color: #333;
            border-color: transparent;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  .error-text {
    color: #FF0D0D;
    font-size: 14px;

    &.avatar {
      position: absolute;
      left: 100%;
      bottom: 10px;
      white-space: nowrap;
    }

    &.ml-20 {
      margin-left: 20px;
    }

    &.mt-10 {
      margin-top: 10px;
    }

    &.select-error {
      position: absolute;
      top: 100%;
      left: 0;
      margin-top: 6px;
    }

    &.protocol {
      position: absolute;
      top: 100%;
      left: 23px;
      margin-top: 6px;
    }
  }

  .settled-in-page-wrap {
    padding: 40px 0 157px;
  }

  .settled-in-page-inner {
    width: 1200px;
    min-height: 400px;
    margin: auto;

    .skill-checking {
      padding-top: 70px;
      display: flex;
      height: 500px;
      justify-content: center;
      background: white;
      img {
        display: block;
        width: 230px;
        height: 104px;
        margin-right: 80px;
      }

      p {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #333333;
        span {
          margin-bottom: 5px;
          &:first-child {
            font-weight: 500;
            line-height: 31px;
            font-size: 22px;
            color: #333;
            margin-bottom: 15px;
            text-align: center;
          }
        }
    
    
      }
    }

    .welcome-text {
      @include flex(flex-start, center);
      height: 80px;
      color: #333;
      font-size: 16px;
      padding: 0 40px;
      border-radius: 8px;
      margin-bottom: 20px;
      background: white;
    }
  }

  .card-item {
    margin-bottom: 20px;
    background: white;

    .card-title {
      @include flex(flex-start, center);
      height: 70px;
      padding-left: 52px;
      border-bottom: 1px solid #F4F4F4;
      font-size: 16px;
      line-height: 22px;

      p {
        position: relative;
        font-weight: 500;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: -12px;
          display: block;
          width: 4px;
          height: 100%;
          background: #FED838;
        }
      }

      span {
        color: #666;
        font-weight: normal;
      }
    }

    &.profile-card {
      .card-body {
        @include flex(flex-start, flex-start);
        height: 285px;
        padding: 30px 0 30px 40px;
      }

      .avatar-box {
        position: relative;
        width: 150px;

        img {
          display: block;
          width: 150px;
          height: 150px;
          border-radius: 100%;
        }

        button {
          display: block;
          width: 100px;
          height: 40px;
          margin: 25px auto 0;
          font-size: 14px;
          font-weight: 500;
        }
      }

      .simple-info {
        margin-left: 67px;
        color: #666;
        font-size: 16px;

        > div {
          @include flex(flex-start);

          &:not(:first-child) {
            margin-top: 50px;
          }

          > div:nth-child(2) {
            margin-left: 16px;
            width: 158px;
          }
        }
      }

      .username {
        width: 158px;
        height: 46px;
        border-radius: 4px;
        padding: 0 10px;
        border: 1px solid #999;
      }

      .radio-group {
        @include flex(flex-start);

        .item:not(:last-child) {
          margin-right: 40px;
        }

        p {
          @include flex();
          cursor: pointer;

          &.checked {
            .radio-block {
              @include flex;
              &:before {
                content: '';
                width: 10px;
                height: 10px;
                background: $color-yellow;
                border-radius: 50%;
              }
            }
          }

          span {
            margin: 0 3px;
          }
        }

        .radio-block {
          display: block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 1px solid $color-gray-2;
        }
        .girl-icon {
          font-size: 14px;
          margin-left: 5px;
          color: rgb(251, 0, 107);
        }
        .boy-icon {
          font-size: 14px;
          margin-left: 5px;
          color: rgb(85, 222, 231);
        }
      }
    }

    &.profile-id-card {
      .card-body {
        @include flex(flex-start, flex-start, column);
        height: 285px;
        padding: 30px 0 50px 40px;
      }
      .text-inputs {
        display: flex;
        align-items: center;
        position: relative;
        .input-id-card {
          border: 1px solid #999999;
          box-sizing: border-box;
          border-radius: 4px;
          padding: 12px 20px;
          font-size: 16px;
          line-height: 22px;
          width: 336px;
          &.input-id-right {
            margin-right: 40px;
          }
        }
        .id-no-error {
          position: absolute;
          top: 100%;
          left: 96px;
          transform: translateY(6px);
          margin-left: 0;
        }
        .realname-error {
          position: absolute;
          top: 100%;
          left: 552px;
          transform: translateY(6px);
          margin-left: 0;
        }
      }
      .content-text {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #666666;
        margin-right: 16px;
      }
      .image-inputs {
        display: flex;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 40px;
        .card-image-wrap {
          width: 186px;
          height: 98px;
          background: #FBFBFD;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          .card-tip-2 {
            position: absolute;
            left: 0;
            bottom: -40px;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            white-space: nowrap;
            pointer-events: none;
            user-select: none;
            text-align: left;
            .error-text {
              margin-left: 0;
            }
          }
          .id-card-bc {
            width: 100%;
            height: 100%;
            background: no-repeat center center / contain;
          }
          .no-image {
            width: 100%;
            height: 100%;
            border: 1px dashed #9FAFDA;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #3F60B5;
            img {
              width: 12px;
              margin-right: 4px;
            }
          }
        }
        .card-image-wrap-back {
          margin-left: 32px;
        }
      }
    }

    &.evidence-card {
      .card-body {
        padding: 24px 40px 46px;

        .text-line {
          color: #666;
          line-height: 170%;
          font-size: 14px;
        }
      }

      .input-box {
        position: relative;
        margin-top: 20px;

        p {
          position: absolute;
          bottom: 10px;
          right: 110px;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          color: #666;

          .error {
            color: #FF0D0D;
          }
        }
      }

      textarea {
        width: 1020px;
        height: 73px;
        border-radius: 4px;
        border: 1px solid #999;
        color: #333;
        padding: 15px;
        font-size: 14px;
        line-height: 20px;
        resize: none;

        &.error {
          border-color: #FF0D0D;
        }

        &::-webkit-input-placeholder {
          color: #999999;
        }
      }

      .pciture-list {
        @include flex(flex-start);
        margin-top: 30px;

        &.aptitudes-1 {
          .right {
            width: 114px;
          }
        }

        &.aptitudes-2 {
          .right {
            width: 385px;
          }
        }

        .left, .right {
          width: 340px;
          height: 192px;
          border-radius: 8px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }

        .left {
          background: #F9FAFB;
          border: 1px solid #dde1e6;
        }

        .middle {
          margin: 0 40px;
          color: #333;
          font-size: 16px;
        }
      }

      button {
        width: 100px;
        height: 40px;
        font-size: 14px;
        margin-top: 20px;
      }
    }

    &.skill-card {

      .card-body {
        @include flex(flex-start);
        padding: 40px;
      }

      .select {
        position: relative;
        width: 290px;
        height: 46px;

        &:after {
          content: '';
          display: block;
          width: 14px;
          height: 14px;
          position: absolute;
          top: 16px;
          right: 15px;
          background: url('~@/assets/images/select-dropdown-icon.png') center center no-repeat;
          background-size: contain;
        }

        input {
          width: 100%;
          height: 100%;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 20px;
          cursor: pointer;

          &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }

      .level-select {
        margin-left: 60px;
      }

      .skill-select,
      .level-select {
        position: relative;
      }
    }

    &.picture-card {
      text-align: left;
      .card-body {
        padding: 30px 40px;

        .text-line {
          color: #666;
          line-height: 170%;
          font-size: 14px;
        }
      }
      .image-list {
        display: flex;
        margin-top: 20px;
        &>div {
          border: 1px solid #DDE1E5;
          border-radius: 4px;
          width: 190px;
          height: 108px;
          background: #fbfbfd no-repeat center center / contain;
          position: relative;
          margin-right: 20px;
        }
        .last-image {
          margin-right: 0;
        }
        .upload-image {
          border: 1px dashed #9FAFDA;
          border-radius: 4px;
          width: 190px;
          height: 108px;
          background: #fbfbfd;
          @include flex;
          >div {
            @include flex;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #3F60B5;
            img {
              width: 12px;
              margin-right: 4px;
            }
          }
        }
        .delete-img {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #333333;
          position: absolute;
          top: -8px;
          right: -8px;
          @include flex;
          img {
            width: 10px;
          }
        }
      }
      .content-tip {
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
      .error-text {
        display: inline-block;
        margin-top: 10px;
        margin-left: 0;
      }
      .image-tip {
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-3;
        margin-top: 20px;
      }
      .example-img-title {
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
        margin-top: 20px;
      }
      .game-tip2 {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .example-img-title {
          margin-top: 0;
          margin-right: 8px;
        }
      }
      .example-img {
        border: 1px solid #DDE1E5;
        border-radius: 4px;
        width: 190px;
        height: 108px;
        background: #fbfbfd no-repeat center center / contain;
        margin-top: 8px;
      }
      .hide-id-btn {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .tips-container {
          font-style: italic;
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
          color: #FFFFFF;
          padding: 1px 3px;
          background: $color-orange;
          border-radius: 5px;
        }
        span {
          font-size: 12px;
          line-height: 17px;
          color: #666666;
          margin: 0 4px 0 8px;
        }
        button {
          font-size: 12px;
          line-height: 17px;
          color: #3E67C5;
        }
      }
    }

    &.self-introduction {
      .card-body {
        padding: 30px 40px 40px;
      }

      .input-box {
        position: relative;

        p {
          position: absolute;
          bottom: 10px;
          right: 110px;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          color: #666;

          .error {
            color: #FF0D0D;
          }
        }
      }

      textarea {
        width: 1020px;
        height: 150px;
        border-radius: 4px;
        border: 1px solid #999;
        color: #333;
        padding: 10px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        resize: none;

        &.error {
          border-color: #FF0D0D;
        }

        &::-webkit-input-placeholder {
          color: #999999;
        }
      }

      .tip-line {
        color: #E26F07;
        font-size: 14px;
        margin-top: 20px;
      }
    }

    &.voice-introduction {
      .card-body {
        padding: 30px 40px 40px;
      }

      .voice-tool-line {
        @include flex(flex-start);
        .upload-btn {
          @include flex();
          width: 132px;
          height: 38px;
          font-size: 14px;
          font-weight: 500;
          border-radius: 20px;
          margin-right: 20px;
          background: #222C43;
          color: #FFFFFF;
          &:focus {
            background: #636D86;
          }
          img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
          }
        }
      }

      .voice-desc-line {
        margin-top: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #666;

        p:last-child {
          color: #E26F07;
          margin-top: 10px;
        }
      }
    }
  }

  .footer-card {
    .profit-line {
      width: 1200px;
      // height: 70px;
      padding: 24px 20px 24px 40px;
      border: 1px solid #ececec;
      border-radius: 8px;
      background: white;

      .title-line {
        @include flex(space-between);
        line-height: 22px;
        user-select: none;
      }

      .body-line {
        margin-top: 11px;

        p {
          line-height: 20px;
          color: #666666;
          font-size: 14px;
        }

        p:last-child {
          margin-top: 10px;
        }
      }

      span {
        color: #3E67C5;
        cursor: pointer;
        font-size: 16px;
        font-weight: normal;
      }

      img {
        width: 30px;
        height: 30px;
        transition: transform .3s;

        &.show {
          transform: rotate(90deg);
        }
      }
    }

    .agreement-line {
      position: relative;
      @include flex(flex-start);
      margin-top: 20px;
      color: #3E67C5;
      font-size: 12px;
      .check-box {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        border-radius: 50%;
        border: 1px solid $color-gray-2;
        @include flex;
        .checked-circle {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: $color-yellow;
        }
      }

      span {
        line-height: 17px;
      }

      p {
        @include flex(flex-start);
        cursor: pointer;
      }

      p:first-child {
        color: #666;
        margin-right: 4px;
      }

      p:nth-child(2) {
        color: #666;

        span {
          color: #3E67C5;
        }
      }
    }

    .submit-btn {
      margin-top: 40px;
      width: 180px;
      height: 46px;
      border-radius: 4px;
      @include button-yellow
    }
  }
.login-body {
  display: flex;
  padding: 10px 52px 0;
  flex-direction: column;
}
.bindphone-footer {
  margin: 30px 0 40px;
  display: flex;
  align-items: center;
}
.affirm-btn {
  width: 100px;
  height: 46px;
  margin-right: 20px;

  button {
    @include flex();
    width: 100%;
    height: 100%;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    border-radius: 4px;
    cursor: pointer;
    @include button-yellow;
  }
}
.need-bind-phone {
  font-size: 14px;
  line-height: 20px;
  color: #FF0D0D;
}
.login-body-mobile-area {
  width: 290px;
  height: 228px;
  overflow: auto;
  border-radius: 4px;
  border: 1px solid #999;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  p {
    @include flex(space-between);
    color: #333;
    font-size: 16px;
    height: 38px;
    margin: 0;
    padding: 0 9px;
    font-weight: 400;
    transition: all 0.2s ease;
    cursor: pointer;
    background: white;

    &:hover {
      background: #f6f6f6;
    }

    span:first-child {
      @include ellipsis;
    }
  }
}
.login-body {
  position: relative;
  // border-top: 1px solid #e0e0e0;
}
.login-body-line {
  position: relative;
  @include flex(flex-start);
  height: 46px;
  box-sizing: border-box;
  font-size: 16px;

  > div {
    @include flex();
    height: 100%;
  }

  input {
    width: 100%;
    height: 100%;
    color: #333;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }

  .mobile-prefix {
    width: 55px;
    flex-shrink: 0;
    cursor: pointer;

    .mobile-prefix-inner {
      @include flex(space-between);
      width: 58px;
      padding-left: 13px;
      span {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
      }
    }

    img {
      width: 10px;
      margin-left: 2px;
    }
  }

  .mobile-input {
    flex-grow: 1;
    margin-left: 14px;
    input{
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
    }
  }

  .valid-code {
    width: 164px;
    border: 1px solid #999;
    border-radius: 4px;
    padding: 0 13px;
    background: #FBFBFB;
  }

  .btn {
    width: 100px;
    margin-left: 10px;

    button {
      @include flex();
      width: 100%;
      height: 100%;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
      @include button-gray-1;
    }
  }
}

.login-body-operation {
  display: inline-block;
  font-size: 0;
  margin-top: 40px;

  p {
    @include flex(flex-start);
    cursor: pointer;
  }

  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }

  span {
    font-size: 13px;
    color: #666;
    line-height: 18px;
  }
}
.error-message {
  position: absolute;
  font-size: 12px;
  line-height: 20px;
  bottom: -22px;
  color: #FE1717;
  left: 0;
}
</style>